<template>
  <div>
    <BaseLayoutSpaced>
      <BaseFormGroup>
        <BaseFormLabel :for="`${_uid}-from`"> From * </BaseFormLabel>

        <BaseFormInput v-model="data.from" :id="`${_uid}-from`" class="block" />
      </BaseFormGroup>

      <BaseFormGroup>
        <BaseFormLabel :for="`${_uid}-subject`"> Subject * </BaseFormLabel>

        <BaseFormInput v-model="data.subject" :id="`${_uid}-subject`" class="block" />
      </BaseFormGroup>

      <BaseFormGroup>
        <BaseFormLabel :for="`${_uid}-message`"> Message * </BaseFormLabel>

        <BaseFormInlineMessage info>
          {{ validTags }}
        </BaseFormInlineMessage>

        <BaseFormTextarea v-model="data.message" :id="`${_uid}-message`" rows="10" class="mt-4" />
      </BaseFormGroup>
    </BaseLayoutSpaced>
  </div>
</template>

<script>
export default {
  props: {
    defaultData: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loading: false,
      data: {
        from: '',
        subject: '',
        message: '',
        ...this.defaultData,
      },
      validTags: [
        '[contact_request:first_name]',
        '[contact_request:last_name]',
        '[contact_request:full_name]',
        '[contact_request:phone]',
        '[contact_request:email]',
      ].toString(),
    };
  },

  watch: {
    data: {
      deep: true,
      handler(data) {
        if (Object.keys(data).some((prop) => !data[prop])) {
          this.$emit('update-props', null);
        } else {
          this.$emit('update-props', data);
        }
      },
    },
  },
};
</script>
